﻿import { IEmailType } from './email-type';

export interface IEmailFamily {
    id: number;
    name: string;
    emailTypes: IEmailType[];
}
